<template>
  <div>
    <Table :columns="columns" :data="resources" size="small" max-height="700" highlight-row stripe>
      <template slot-scope="{ row }" slot="table_id">
        {{ row.table ? row.table.table_no : '' }}
      </template>
      <template slot-scope="{ row }" slot="invoice_no">
        {{ row.invoice ? row.invoice.invoice_no : '' }}
      </template>
      <template slot-scope="{ row }" slot="created_by">
        {{ row.user ? row.user.name : '' }}
      </template>
      <template slot-scope="{ row }" slot="floors">
        {{ row.table ? row.table.floors : '' }}
      </template>
      <template slot-scope="{ row }" slot="max_num_person">
        {{ row.table ? row.table.max_num_person : '' }}
      </template>
      <template slot-scope="{ row }" slot="deleted_by">
        {{ row.deletedBy ? row.deletedBy.name : '' }}
      </template>
      <template slot-scope="{ row }" slot="grand_total">
        {{ row.invoice ? row.invoice.grand_total : '' }}
      </template>
      <template slot-scope="{ row }" slot="order_no">
        {{ row.invoice ? row.invoice.order_no : '' }}
      </template>
      <template slot-scope="{ row }" slot="stock_out_date">
        {{
          row.invoice && row.invoice.stock_out_date
            ? formatDate(row.invoice.stock_out_date)
            : ''
        }}
      </template>
    </Table>
  </div>
</template>
<script>
import { min } from 'lodash'
import moment from 'moment'
export default {
  name: 'table-expand',
  props: {
    records: Array
  },
  data() {
    return {
      visible: false
    }
  },
  computed: {
    resources() {
      return this.records
    },
    columns() {
      return [
        {
          title: this.$t('customerMemberCard.stockOutDate'),
          slot: 'stock_out_date',
          width: 200,
        },
        {
          title: this.$t('customerMemberCard.invoiceNumber'),
          slot: 'invoice_no',
          width: 200
        },
        {
          title: this.$t('customerMemberCard.orderNumber'),
          slot: 'order_no',
          width: 200,
        },
        {
          title: this.$t('customerMemberCard.locker'),
          slot: 'table_id',
          width: 200
        },
        {
          title: this.$t('customerMemberCard.grandTotal'),
          slot: 'grand_total',
          width: 150,
          align: 'center'
        },
        {
          title: this.$t('customerMemberCard.floor'),
          slot: 'floors',
          width: 150,
          align: 'center'
        },
        {
          title: this.$t('customerMemberCard.maxNumPerson'),
          slot: 'max_num_person',
          width: 150,
          align: 'center'
        },
        {
          title: this.$t('customerMemberCard.createdBy'),
          slot: 'created_by',
          width: 200
        },
        {
          title: this.$t('customerMemberCard.createdDate'),
          key: 'created_date',
          minWidth: 200
        }
      ]
    }
  },
  methods: {
    formatDate(date) {
      return moment(date).format('DD-MM-YYYY hh:mm:ss A')
    },

    handleCancel() {
      this.visible = false
      this.$emit('cancel')
    }
  }
}
</script>
